import { useCallback, useState } from 'react';

import { ComposerUnits } from '../../composerTypes';

export interface ComposerDisplaySettingsInitialState {
  showDimensions?: boolean;
  units?: ComposerUnits;
}

function useComposerDisplaySettings(
  initialState?: ComposerDisplaySettingsInitialState
) {
  const [showDimensions, setShowDimensionsState] = useState(
    initialState?.showDimensions ?? false
  );
  const [units, setUnitsState] = useState<ComposerUnits>(
    initialState?.units ?? ComposerUnits.CM
  );

  const toggleShowDimensions = useCallback(() => {
    setShowDimensionsState((prev) => !prev);
  }, []);

  const setUnits = useCallback((next: ComposerUnits) => {
    setUnitsState(next);
  }, []);

  return {
    showDimensions,
    units,
    toggleShowDimensions,
    setUnits
  };
}

export default useComposerDisplaySettings;
